
<template>
    <div>
        <gofix-card title="Contract variation" v-bind:key="index + 'variation'" v-for="(item, index) in value">
            <template slot="gofixCard:right_header">
                <div class="contract-attachment-action">
                    <b-button class="btnDelete" @click="removeOption(index, item)" title="Delete" v-b-tooltip.hover><i class="fa fa-trash-o"></i></b-button>
                </div>
            </template>
            <b-row>
                <b-col md="2">
                    <gofix-form-input-number
                        label="amount"
                        allowNegative
                        v-model="item.json_content.amount"
                        prefix="$">
                    </gofix-form-input-number>
                </b-col>
                <b-col md="4">
                    <b-row>
                        <b-col md="12">
                            <gofix-form-input label="Description" v-model="item.json_content.description"></gofix-form-input>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </gofix-card>
    </div>
</template>
<script>
    export default {
        name: 'contract-variation-info',
        props: {
            value: {
                type: Array,
                required: true,
                default: () => []
            }
        },
        data() {
            return {}
        },
        methods: {
            removeOption(index, item) {
                this.$emit('removeItem', 'contract_variation_info', index, item);
            }
        }
    }
</script>
